export default "__VITE_PUBLIC_ASSET__dd829498__"